<!--
 * @Description:
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-19 11:44:37
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 16:52:52
-->
<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
             "parkCode":""
            },
            responseCode: {
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 根据车场车场编码获取收费信息",
                t_url: this.commonUrls.test+"getParkYdtCharge",
                p_url: this.commonUrls.prod+"getParkYdtCharge",
                precondition: "无",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                            { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                            { info1: 'startDateTime', info2: '否', info3: 'String', info4: '开始时间' }
                        ]
                }
                ],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [ { info1: 'carType', info2: '否', info3: 'String', info4: '是否区分车辆类型(0:不区分，1:区分' },
                      { info1: 'workDay', info2: '否', info3: 'String', info4: '是否区分工作日(0:不区分，1:区分) VEMS会有设置是否区分 如果是区分的时候 只展示查费结果 前端不展示具体收费时段' },
                      { info1: 'parkYdtChargeStandardVoList', info2: '否', info3: 'array', info4: '收费规则' },]
                },
                  {
                    titleName: 'parkYdtChargeStandardVoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'standardSeq', info2: '否', info3: 'Integer', info4: '收费规则标准主键ID' },
                      { info1: 'type', info2: '否', info3: 'String', info4: '收费规则标准类型（0自定义，1免费规则，2循环递增，3按次固定） VEMS没有 设置为0 或者VEMS没开启计费服务 则是设置为免费' },
                      { info1: 'carType', info2: '否', info3: 'String', info4: '车辆类型' },
                      { info1: 'carTypeName', info2: '否', info3: 'String', info4: '车辆类型名称 如果是区分车型 就会有值' },
                      { info1: 'freeTime', info2: '否', info3: 'String', info4: '免费时长 多少分钟内免费' },
                      { info1: 'maxCharge', info2: '否', info3: 'String', info4: '24小时封顶金额' },
                      { info1: 'customMaxUnit', info2: '否', info3: 'String', info4: '自定义封顶时长，时长<1440分钟' },
                      { info1: 'customMaxCharge', info2: '否', info3: 'String', info4: '自定义封顶时长对应金额' },
                      { info1: 'chargeMap', info2: '否', info3: 'Map', info4: '查费结果' },
                    ]
                  }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getParkYdtCharge.vue